
export default {
  props: {
    href: { type: String, default: null },
    theme: { type: String, default: 'default' },
    loading: { type: Boolean, default: false },
    direction: { type: String, default: 'right' },
  }
}
